// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1uCI6","header":"Messages_header__3jTi8"};